module.exports = __webpack_public_path__ + "img/1.1a04c6d4.webp";